<template>
  <layout-form>
    <select-now />
    <input-memo />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib/Layout/Form'
import SelectNow from './SelectNow'
import InputMemo from './InputMemo'

export default {
  components: {
    LayoutForm,
    SelectNow,
    InputMemo
  }
}
</script>
